module.exports = __webpack_public_path__ + "static/media/add.35efe7a0.svg";